export default {
  metrics: {
    nrr: {
      title: 'NRR % (Quarterly)',
      description:
        '(Subscription revenue {{currentMonth}} (Q{{currentQuarter}}) + Service fee revenue {{currentMonth}} (Q{{currentQuarter}})) / (Subscription revenue {{prevMonth}} (end of Q{{prevQuarter}}) + Service fee revenue {{prevMonth}} (end of Q{{prevQuarter}})) * 100',
    },
    upgrades: 'Account Upgrades',
    downgrades: 'Account Downgrades',
    gte_c_tier: 'Accounts ≥ C Grade',
    churn: 'Churn (suspended)',
    offers_turned_on: 'Offers turned on',
    flyers_sent: 'Flyers sent',
    on_google_ads_trial: 'On Google Ads trial',
    converted_google_ads: 'Successfully converted Google Ads',
    first_time_500_monthly_sales: 'First-time €500 month',
    '14_days_no_sales': '14 days live, no revenue',
  },
  details: {
    address: 'Address',
    subscriptions: 'Current subscriptions',
    best_sales: 'Best-ever monthly',
    sales: '{{month}} Sales',
    tier: '{{month}} tier',
    live_from: 'Go-Live date',
    owner_phone: 'Owner phone',
    owner_email: 'Owner email',
    owner: 'Owner name',
    name: 'Restaurant',
    export_csv: 'Export CSV',
  },
  publish: 'Publish',
  unpublish: 'Unpublish',
};
